/* -----------------Globals--------------- */
import { useCallback, useState } from "react";

import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------UI--------------- */
import { IconButton, Menu } from "react-native-paper";

/* -----------------Types--------------- */
import type { GetMessageActions } from "../types";

type Props = {
	messageActions: GetMessageActions;
	showEmail?: boolean;
	content?: string;
	runId?: string;
};

export const MessageMenuActions = ({
	messageActions,
	showEmail,
	content,
	runId,
}: Props) => {
	const [visible, setVisible] = useState(false);

	const openMenu = useCallback(() => {
		setVisible(true);
	}, []);

	const closeMenu = () => {
		setVisible(false);
	};

	return (
		<Menu
			visible={visible}
			onDismiss={closeMenu}
			anchor={<IconButton icon="dots-vertical" onPress={openMenu} />}
		>
			{messageActions(showEmail, runId).map(
				({ icon, altText, handleOnPress }) => (
					<Menu.Item
						key={icon}
						leadingIcon={(props) => (
							<Icon
								{...props}
								name={icon as React.ComponentProps<typeof Icon>["name"]}
								size={20}
							/>
						)}
						title={altText}
						onPress={() => {
							handleOnPress(content);
							closeMenu();
						}}
					/>
				),
			)}
		</Menu>
	);
};
